export const constants = {
  greetings: {
    title: "Greetings",
    addButtonTitle: "Add Greeting",
    noRecordsMatch: "No matches found. Please try another search.",
    noRecords: "No greetings added yet.",
  },
  greetingsDetails: {
    title: "Greeting Details",
    backButton: " Back to Greetings",
  },
};
